import { Accordion } from '@curology/ui-components-web/react/Accordion';
import { AccordionContent } from '@curology/ui-components-web/react/Accordion/AccordionContent';
import { AccordionSummary } from '@curology/ui-components-web/react/Accordion/AccordionSummary';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useState } from 'react';

const ConsultationStayTuned: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="cur-w-full cur-flex-col cur-cursor-pointer cur-mt-4 cur-p-4 cur-bg-surface-highlight cur-text-curology-secondary">
        <Typography size="h3">
          Stay tuned! Your{' '}
          <span className="cur-text-curology-brand ">
            dermatology consultation
          </span>{' '}
          will continue after you check out.
        </Typography>
        <Accordion
          className="cur-mt-3"
          open={isOpen}
          onToggle={() => setIsOpen((prevOpen) => !prevOpen)}
        >
          <AccordionSummary>
            <Typography size="body" weight="bold">
              How does the consultation work?
            </Typography>
          </AccordionSummary>
          <AccordionContent
            className="cur-p-0"
            style={{ lineHeight: '1.25rem' }}
          >
            We’ll ask quiz questions about your skin and health history. Plus,
            we’ll ask for photos of your skin.
            <br />
            <br />
            After one of our licensed dermatology providers reviews your
            “skinfo,” they prescribe your personalized formula. We’ll notify you
            when your treatment plan is ready—usually within 1-2 business days!
          </AccordionContent>
        </Accordion>
      </div>
    </>
  );
};

export default ConsultationStayTuned;
